import globalStore from '$$globalStore';

function onResourceCreated(event) {
  globalStore.commit('resourcesModel/addResources', event.data.resources);
}

export default onResourceCreated;
